import $axios from '~/plugins/axios';
import { Api, CamapignSplitFilterGroupRequest, CampaignSplitFilterGroup } from '~/api';
import { buildModule } from '~/store/utils';
import { Dict } from '~/helpers';

const api = $axios as Api;

export default buildModule()
	.withState({
		filterGroupById: {} as Dict<CampaignSplitFilterGroup>,
	})
	.withGetters({
		byId: (state) => (id: number): CampaignSplitFilterGroup | null => state.filterGroupById[id] ?? null,
	})
	.withMutations({
		SET_FILTER_GROUP (state, filterGroup: CampaignSplitFilterGroup) {
			state.filterGroupById = { ...state.filterGroupById, [filterGroup.id]: filterGroup };
		},
	})
	.withActions({
		async get ({ commit }, id: number) {
			const { data } = await api.get(`/campaign/split/filter-group/${ id }`);
			commit('SET_FILTER_GROUP', data.payload);
		},
		async post ({ commit }, request: CamapignSplitFilterGroupRequest) {
			const { data } = await api.post('/campaign/split/filter-group', request);
			commit('SET_FILTER_GROUP', data.payload);
			return data.payload;
		},
		async update ({ commit }, { id, ...request }: { id: number } & CamapignSplitFilterGroupRequest) {
			const { data } = await api.put(`/campaign/split/filter-group/${ id }`, request);
			commit('SET_FILTER_GROUP', data.payload);
			return data.payload;
		},
		async delete (_, id: number) {
			await api.delete(`/campaign/split/filter-group/${ id }`);
		},
	});
